import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StoreContextService } from '../services/store-context.service';

@Injectable({ providedIn: 'root' })
export class StoreGuard implements CanActivate {
  constructor(
    private storeContextService: StoreContextService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const stores = this.storeContextService.stores;
    if (stores.length === 0) {
      return true;
    }

    if (stores.length === 1 && !this.storeContextService.selectedStoreCode) {
      this.storeContextService.setSelectedStoreCode(stores[0].code);
      return true;
    }

    const selected = this.storeContextService.selectedStoreCode;
    if (!selected || !stores.some(x => x.code === selected)) {
      this.router.navigate(['/select-store']);
      return false;
    }

    return true;
  }
}
